module.exports = __webpack_public_path__ + "img/ICONE-JURISTE.b7823d41.svg";